import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tongji-h",
  "use": "icon-tongji-h-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tongji-h\"><path fill=\"currentColor\" d=\"M534.75392 0.64l-20.468 0 0 468.719c0 7.685 2.558 12.805 7.676 17.929 5.114 5.119 12.792 7.685 17.912 7.685l483.583 0 0-20.494C1026.01392 208.104 808.53092 0.64 534.75392 0.64L534.75392 0.64zM555.22192 453.99 555.22192 41.624C790.62092 51.868 972.28292 228.597 982.52092 453.99L555.22192 453.99 555.22192 453.99zM486.14292 1022.6c271.214 0 493.818-212.59 493.818-476.405l0-20.489L481.02292 525.706 481.02292 41.623l-20.466 0C207.24692 41.624-0.00208 267.014-0.00208 543.635-0.00208 812.572 214.92192 1022.6 486.14292 1022.6L486.14292 1022.6zM437.52492 85.165l0 458.469c0 7.684 2.563 12.805 7.677 17.928 5.118 5.124 12.795 7.687 17.91 7.687l473.35 0c-10.235 227.958-209.807 412.368-450.32 412.368-248.19 0-445.205-192.095-445.205-437.982C40.93792 297.749 217.47992 95.409 437.52492 85.165L437.52492 85.165z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tongji-h.svg
// module id = E8bc
// module chunks = 102